export enum IGoalActionTypes {
  FETCH_COMPANY_GOALS_REQUEST = "FETCH_COMPANY_GOALS_REQUEST",
  FETCH_COMPANY_GOALS_SUCCESS = "FETCH_COMPANY_GOALS_SUCCESS",
  FETCH_COMPANY_GOALS_FAILURE = "FETCH_COMPANY_GOALS_FAILURE",

  FETCH_TEAM_GOALS_REQUEST = "FETCH_TEAM_GOALS_REQUEST",
  FETCH_TEAM_GOALS_SUCCESS = "FETCH_TEAM_GOALS_SUCCESS",
  FETCH_TEAM_GOALS_FAILURE = "FETCH_TEAM_GOALS_FAILURE",

  FETCH_SUBTEAM_GOALS_REQUEST = "FETCH_SUBTEAM_GOALS_REQUEST",
  FETCH_SUBTEAM_GOALS_SUCCESS = "FETCH_SUBTEAM_GOALS_SUCCESS",
  FETCH_SUBTEAM_GOALS_FAILURE = "FETCH_SUBTEAM_GOALS_FAILURE",

  FETCH_INDIVIDUAL_GOALS_REQUEST = "FETCH_INDIVIDUAL_GOALS_REQUEST",
  FETCH_INDIVIDUAL_GOALS_SUCCESS = "FETCH_INDIVIDUAL_GOALS_SUCCESS",
  FETCH_INDIVIDUAL_GOALS_FAILURE = "FETCH_INDIVIDUAL_GOALS_FAILURE",

  FETCH_TASKS_REQUEST = "FETCH_TASKS_REQUEST",
  FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS",
  FETCH_TASKS_FAILURE = "FETCH_TASKS_FAILURE",
}

export type IGoalsListState = {
  company_goals_data: [];
  team_goals_data: [];
  subteam_goals_data: [];
  individual_goals_data: [];
  task_details: [];
};
